import React from "react";
import "./NavBar.css";
import "./NavBar_Responsive.css";
import { FaGithub } from "react-icons/fa";

//Components
import Button from "../Button/Button.js";

//Images
import MenuIcon from "../../assets/icons/menu.png";
import { Link } from "react-router-dom";

export default class NavBar extends React.Component {
  displayNavBar() {
    var responsiveMenu = this.refs.navMenu;
    if (!responsiveMenu) return;
    var isMenuVisible = window.getComputedStyle(responsiveMenu).right === "0px";

    if (!isMenuVisible) responsiveMenu.style.right = "0px";
    else responsiveMenu.style.right = "-400px";
  }

  render() {
    return (
      <div className="navBarContainer">
        <div className="navBarContent">
          <div className="logo">
            <h2 className="regularText">
              <a href="https://github.com/WillieRivera" target="_blank">
                <FaGithub />
                Github
              </a>
            </h2>
          </div>
          <a
            className="navResponsiveButton"
            onClick={() => {
              this.displayNavBar();
            }}
          >
            <img src={MenuIcon} />
          </a>
          <div ref="navMenu" className="navLinks normal">
            <Link
              to="/"
              onClick={() => {
                this.displayNavBar();
              }}
              className="navLink "
            >
              Home
            </Link>

            <Link
              to="/about"
              onClick={() => {
                this.displayNavBar();
              }}
              className="navLink "
            >
              About
            </Link>

            <Link
              to="/projects"
              onClick={() => {
                this.displayNavBar();
              }}
              className="navLink "
            >
              Projects
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
